import Vue from "vue";
import VueResource from "vue-resource";
import { API_ROOT } from "../config";

Vue.use(VueResource);

// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true

/*if (process.env.NODE_ENV === "production") {
  throw new Error("Missing API root");
  // Vue.http.options.root = ...
}*/

Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {};
  request.headers.set("Authorization", localStorage.getItem("Authorization"));
  next(response => {
    if (response.status === 401) {
      if (!window.location.pathname === "/login")
        window.location.pathname = "/login";
    }
  });
});

export const AuthResource = Vue.resource(API_ROOT + "auth");
export const SignUpResource = Vue.resource(API_ROOT + "signup");
export const ActivateAccountResource = Vue.resource(
  API_ROOT + "activate/{token}"
);
export const MySelfResource = Vue.resource(API_ROOT + "myself");
export const ForgotPasswordResource = Vue.resource(
  API_ROOT + "forgot_password"
);
export const ResetPasswordResource = Vue.resource(
  API_ROOT + "reset_password{/token}"
);

export const CreatePersonResource = Vue.resource(API_ROOT + "person");
export const PersonResource = Vue.resource(API_ROOT + "person");
export const PersonDeleteResource = Vue.resource(API_ROOT + "person/{id}");
export const PersonDeactivateResource = Vue.resource(API_ROOT + "person/deactivate/{id}");
export const PersonUpdateResource = Vue.resource(API_ROOT + "person/{id}");
export const PersonHistoryResource = Vue.resource(API_ROOT + "person/{id}");

export const UserResource = Vue.resource(API_ROOT + "user");
export const UserCreateResource = Vue.resource(API_ROOT + "user");
export const UserReadResource = Vue.resource(API_ROOT + "user/{id}");
export const UserUpdateResource = Vue.resource(API_ROOT + "user/{id}");
export const UserDeleteResource = Vue.resource(API_ROOT + "user/{id}");


export const EventResource = Vue.resource(API_ROOT + "event");
export const EventDeleteResource = Vue.resource(API_ROOT + "event/{id}");
export const EventUpdateResource = Vue.resource(API_ROOT + "event/{id}");
export const EventCreateResource = Vue.resource(API_ROOT + "event");

export const SectionResource = Vue.resource(API_ROOT + "section");
export const SectionCreateResource = Vue.resource(API_ROOT + "section");
export const SectionUpdateResource = Vue.resource(API_ROOT + "section/{id}");
